import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './VerificationSuccessed.scss';

const VerificationSuccessed = () => {
  const { t } = useTranslation('global');
  const navigate = useNavigate();

  return (
    <div className="verification-success">
      <div className="verification-success__content">
        <div className="verification-success__icon">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" fill="#4CAF50"/>
          </svg>
        </div>
        <h1 className="verification-success__title">{t('verification.congratulations')}</h1>
        <p className="verification-success__message">{t('verification.verificationComplete')}</p>
        <button 
          className="verification-success__button"
          onClick={() => navigate('/profile')}
        >
          {t('verification.backToProfile')}
        </button>
      </div>
    </div>
  );
};

export default VerificationSuccessed;